import Route from 'cio/routes/base';

import NewsletterModel from 'cio/models/newsletter';

export default class OverviewRoute extends Route {
  redirect(model: NewsletterModel) {
    if (!model.isSent) {
      // also redirect to setup "review" page for scheduled newsletters:
      this.router.transitionTo('broadcasts.newsletter.setup', model);
    }
  }
}
